// Module
var code = "<strong>Planung und Konstruktion</strong>";
// Exports
module.exports = code;